export default function ListIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.6665 26H27.9998" stroke="#560BA2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M14.6665 16.6665H27.9998" stroke="#560BA2" strokeWidth="1.5" strokeLinecap="round"
            strokeLinejoin="round"/>
      <path d="M14.6665 7.3335H27.9998" stroke="#560BA2" strokeWidth="1.5" strokeLinecap="round"
            strokeLinejoin="round"/>
      <path d="M4 7.33317L5.33333 8.6665L9.33333 4.6665" stroke="#560BA2" strokeWidth="1.5" strokeLinecap="round"
            strokeLinejoin="round"/>
      <path d="M4 16.6667L5.33333 18L9.33333 14" stroke="#560BA2" strokeWidth="1.5" strokeLinecap="round"
            strokeLinejoin="round"/>
      <path d="M4 26.0002L5.33333 27.3335L9.33333 23.3335" stroke="#560BA2" strokeWidth="1.5" strokeLinecap="round"
            strokeLinejoin="round"/>
    </svg>
  )
}
